var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7505 18.9395H11.4975C11.0835 18.9395 10.7475 18.6035 10.7475 18.1895C10.7475 17.7755 11.0835 17.4395 11.4975 17.4395H18.7505C19.1645 17.4395 19.5005 17.7755 19.5005 18.1895C19.5005 18.6035 19.1645 18.9395 18.7505 18.9395Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1103 2.01664L1.69527 13.7916C1.52427 14.0056 1.46127 14.2816 1.52427 14.5466L2.20527 17.4316L5.24427 17.3936C5.53327 17.3906 5.80027 17.2616 5.97727 17.0416C9.19427 13.0166 15.3273 5.34264 15.5013 5.11764C15.6653 4.85164 15.7293 4.47564 15.6433 4.11364C15.5553 3.74264 15.3243 3.42764 14.9913 3.22664C14.9203 3.17764 13.2353 1.86964 13.1833 1.82864C12.5493 1.32064 11.6243 1.40864 11.1103 2.01664ZM1.61327 18.9396C1.26627 18.9396 0.964274 18.7016 0.883274 18.3626L0.0642743 14.8916C-0.104726 14.1726 0.0632743 13.4306 0.524274 12.8546L9.94427 1.07264C9.94827 1.06864 9.95127 1.06364 9.95527 1.05964C10.9883 -0.175357 12.8563 -0.357357 14.1163 0.653643C14.1663 0.692643 15.8393 1.99264 15.8393 1.99264C16.4473 2.35464 16.9223 3.00164 17.1023 3.76764C17.2813 4.52564 17.1513 5.30764 16.7343 5.96864C16.7033 6.01764 16.6763 6.05964 7.14827 17.9796C6.68927 18.5516 6.00127 18.8846 5.26227 18.8936L1.62327 18.9396H1.61327Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2231 8.68464C14.0631 8.68464 13.9031 8.63364 13.7661 8.52964L8.31407 4.34164C7.98607 4.08964 7.92407 3.61964 8.17607 3.28964C8.42907 2.96164 8.89907 2.90064 9.22807 3.15264L14.6811 7.33964C15.0091 7.59164 15.0711 8.06264 14.8181 8.39164C14.6711 8.58364 14.4481 8.68464 14.2231 8.68464Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e82fefbad67d7cbf7c0fe164cca23d56.svg";
export { ForwardRef as ReactComponent };